import React from 'react';
import PropTypes from 'prop-types';

import { Input, Text, PasswordInput, PhoneFormat } from '../index';

const STATE = Object.freeze({
    PASSWORD: 'PASSWORD',
    REQUEST: 'REQUEST',
    OTP: 'OTP',
    CONFIRM_PASSWORD: 'CONFIRM_PASSWORD',
});

export const SignInForm = ({
    data,
    onChange,
    onForgotPassword,
    onResendOTP,
    OTPRef,
    state,
    countdown,
    onPressEnterPhoneInput,
    onPressEnterOTPInput,
    onPressEnterPasswordInput,
    onPressEnterConfirmPasswordInput,
    errors,
    phoneEmailInput,
}) => {
    return (
        <div
            style={{
                display: 'grid',
                gridTemplateRows: '1fr minmax(auto, 85%)',
                height: '100%',
                rowGap: '15px',
            }}
        >
            {state === STATE.PASSWORD && (
                <Input
                    id="mobile-phone"
                    label={phoneEmailInput ? 'Mobile phone or Email' : 'Mobile phone'}
                    placeholder={phoneEmailInput ? 'Mobile phone or Email' : 'Mobile phone'}
                    name="phone"
                    onChange={onChange}
                    value={data.phone}
                    onEnter={onPressEnterPhoneInput}
                    InputProps={
                        phoneEmailInput
                            ? {}
                            : {
                                  inputComponent: PhoneFormat,
                              }
                    }
                    helperText={errors.find((value) => value.property === 'phone')?.message}
                />
            )}
            {state === STATE.REQUEST && (
                <Input
                    id="mobile-phone"
                    label="Mobile phone"
                    placeholder="Mobile phone"
                    name="phone"
                    onChange={onChange}
                    value={data.phone}
                    onEnter={onPressEnterPhoneInput}
                    InputProps={{
                        inputComponent: PhoneFormat,
                    }}
                    helperText={errors.find((value) => value.property === 'phone')?.message}
                />
            )}
            {(state === STATE.OTP || state === STATE.CONFIRM_PASSWORD) && (
                <div>
                    <Input
                        id="otp"
                        label="OTP"
                        placeholder="OTP"
                        name="otp"
                        onChange={onChange}
                        value={data.otp}
                        onEnter={onPressEnterOTPInput}
                        helperText={errors.find((value) => value.property === 'otp')?.message}
                        max={10}
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Text $color="gray2" $fontSize="14px">
                            {`Ref. Code : ${OTPRef}`}
                        </Text>
                        <Text
                            $color={countdown > 0 ? 'gray4' : 'purple'}
                            $fontSize="14px"
                            style={{ textDecoration: 'underline' }}
                            onClick={countdown > 0 ? null : onResendOTP}
                        >
                            {countdown > 0 ? `Resend OTP (Wait ${countdown}s)` : 'Resend OTP'}
                        </Text>
                    </div>
                </div>
            )}
            {(state === STATE.PASSWORD || state === STATE.CONFIRM_PASSWORD) && (
                <div>
                    <PasswordInput
                        id="password"
                        label="Password"
                        placeholder="Password"
                        name="password"
                        onChange={onChange}
                        value={data.password}
                        onEnter={onPressEnterPasswordInput}
                        helperText={errors.find((value) => value.property === 'password')?.message}
                    />
                    {state === STATE.PASSWORD && (
                        <Text
                            $color="gray1"
                            $fontSize="14px"
                            style={{ textDecoration: 'underline', textAlign: 'right' }}
                            onClick={onForgotPassword}
                        >
                            Forgot password
                        </Text>
                    )}
                </div>
            )}
            {state === STATE.CONFIRM_PASSWORD && (
                <PasswordInput
                    id="confirmPassword"
                    label="Confirm password"
                    placeholder="Confirm Password"
                    name="confirmPassword"
                    onChange={onChange}
                    value={data.confirmPassword}
                    onEnter={onPressEnterConfirmPasswordInput}
                    helperText={
                        errors.find((value) => value.property === 'confirmPassword')?.message
                    }
                />
            )}
        </div>
    );
};

SignInForm.propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func,
    onForgotPassword: PropTypes.func,
    onResendOTP: PropTypes.func,
    OTPRef: PropTypes.any,
    state: PropTypes.string,
    countdown: PropTypes.number,
    onPressEnterPhoneInput: PropTypes.func,
    onPressEnterOTPInput: PropTypes.func,
    onPressEnterPasswordInput: PropTypes.func,
    onPressEnterConfirmPasswordInput: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.object),
    phoneEmailInput: PropTypes.bool,
};
